/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Slimy_Maroon_Gopher_BoilInputs */

const fr_slimy_maroon_gopher_boil = /** @type {(inputs: Slimy_Maroon_Gopher_BoilInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crée ton mot de passe afin d'utiliser l'application et indique ton numéro de téléphone.`)
};

/**

* @param {Slimy_Maroon_Gopher_BoilInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const slimy_maroon_gopher_boil = /** @type {((inputs?: Slimy_Maroon_Gopher_BoilInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slimy_Maroon_Gopher_BoilInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_slimy_maroon_gopher_boil(inputs)
});